import React from 'react';
import Footer from './Footer';
import Header from './Header';
import Main from './Main';

const Views = () => {
    return (
        <>
            <Header />
            <Main />
            <Footer />
        </>
    );
};

export default Views;